<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索商品" v-model="pageInfo.productName" >
            <div class="right fs-28 color-333 click" @click="$router.push({name:'saveProduct'})">
                新增商品
            </div>
        </div>
        <div class="page-state">
            <van-tabs v-model="state" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.name" v-for="(item,$index) in tabList" :key="$index"></van-tab>
            </van-tabs>
        </div>

        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="product-item" >
                    <div class="flex pd-250" @click="getScrollerPosition();$router.push({name:'saveProduct',query:{itemId: item.itemId}})">
                        <div class="item-img">
                            <img :src="item.mainPicView" alt="">
                        </div>
                        <div class="flex1 ofh">
                            <div class="name fs-28 color-333">{{item.productName}}</div>
                            <div class="bot flex-between fs-28 color-999">
                                <div>销售价：￥{{item.specialPrice}}</div>
                                <div>库存：{{item.stockNum}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="bd-top item-bot">
                        <div class="fs-26 color-999 click" :class="item.state == 0?'text-center w100':''" @click="remove(item)">删除</div>
                        <div class="btn-group flex" v-if="item.state != 0">
                            <div class="btn click color-main" @click="getScrollerPosition();$router.push({name:'saveProduct',query:{itemId: item.itemId}})">修改</div>
                            <div class="btn click color-org" v-if="item.state == 1" @click="updateState(item,'确定要下架该商品吗？', 2)">下架</div>
                            <div class="btn click color-org" v-if="item.state != 1 && item.state != 3" @click="updateState(item,'确定要上架该商品吗？', 1)">上架</div>
                        </div>
                    </div>
                    <div class="color-red fs-28 pb-20" v-if="item.state == 3">失败原因：{{item.checkReason}}</div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import {updateProductState,removeProduct} from "@/api/product"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "productList",
        mixins: [initData,routerBack,getAppStatusHeight],
        components:{appStatus},
        data(){
            return{
                state:1,
                tabList:[
                    {title:'已上架',name:1},
                    // {title:'未上架',name:100},
                    {title:'已下架',name:2},
                    {title:'审核中',name:0},
                    {title:'审核失败',name:3}
                ],
                shopId:this.$store.state.user.shopId,
            }
        },
        methods:{
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                this.params = { page : this.page, limit: this.limit,shopId:this.shopId,state: this.state};
                this.url = 'item/shopItem';
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },
            //切换状态
            tabClick(name){
                this.state = name;
                this.handleQuery();
            },
            //上架、下架
            updateState(data,tip,state){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: tip,
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        updateProductState({itemId:data.itemId,state}).then(res=>{
                            _this.$toast("操作成功");
                            _this.handleQuery();
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },
            //删除
            remove(data){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: '确定要删除该商品吗？',
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        removeProduct({itemId:data.itemId}).then(res=>{
                            _this.$toast("操作成功");
                            _this.handleQuery();
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "saveProduct") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack || this.$store.state.updateProductList) {
                this.$store.state.updateProductList = false;
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }

</script>

<style scoped lang="scss">
    .product-item{
        margin: .2rem .24rem;
        padding: 0 .24rem;
        background: #fff;
        border-radius: .12rem;
        .item-img{
            width: 1.72rem;
            height: 1.72rem;
            margin-right: .24rem;
        }
       .name{
           height: .8rem;
           display: -webkit-box;
           -webkit-box-orient: vertical;
           -webkit-line-clamp: 2;
           overflow: hidden;
       }
        .bot{
            margin-top: .55rem;
        }
        .item-bot{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .2rem 0;
        }
        .btn{
            width: 1.64rem;
            height: .56rem;
            text-align: center;
            line-height: .56rem;
            background: #F4F4F4;
            border-radius: .08rem;
            font-size: .26rem;
            margin-left: .2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// productList.vue?04a80562